import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task, waitForProperty } from 'ember-concurrency';
import config from 'garaje/config/environment';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import { OauthProvider } from 'roomba/graphql/generated/graphql-types';
let RoombaSettingsIndexController = (_class = class RoombaSettingsIndexController extends Controller {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "featureConfig", _descriptor, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor2, this);
    _initializerDefineProperty(this, "graphql", _descriptor3, this);
    _initializerDefineProperty(this, "roombaMetrics", _descriptor4, this);
    _initializerDefineProperty(this, "state", _descriptor5, this);
    _initializerDefineProperty(this, "settingsAccessCode", _descriptor6, this);
    _initializerDefineProperty(this, "selectedDeleteConnection", _descriptor7, this);
    _initializerDefineProperty(this, "deleteConnectionShouldRemoveRooms", _descriptor8, this);
    _defineProperty(this, "refreshRoomList", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          this.roombaMetrics.trackEvent('calendar_settings_refresh_calendars_clicked', {
            locationId: this.state.currentLocation?.id
          });
          const {
            errors
          } = yield this.graphql.synchronizeCompanyRoomList();
          if (errors.length === 0) {
            this.flashMessages.showAndHideFlash('success', 'Calendars synced!');
          } else {
            this.flashMessages.showAndHideFlash('warning', 'Encountered some errors while syncing calendars.');
            console.error('refreshRoomList errors:', errors); // eslint-disable-line no-console
          }
        } catch {
          this.flashMessages.showAndHideFlash('error', 'Error syncing calendars.');
        }
        this.selectedDeleteConnection = null;
        this.deleteConnectionShouldRemoveRooms = false;
      }
    }), {
      drop: true
    }, "refreshRoomList", null));
    _defineProperty(this, "deleteConnection", _buildTask(() => ({
      context: this,
      generator: function* () {
        try {
          this.roombaMetrics.trackEvent('calendar_settings_remove_calendar_clicked', {
            locationId: this.state.currentLocation?.id
          });
          if (this.selectedDeleteConnection != null) {
            yield this.graphql.unlinkConnection({
              connectionId: this.selectedDeleteConnection.id,
              shouldDeleteAssociatedRooms: this.deleteConnectionShouldRemoveRooms
            });
            this.flashMessages.showAndHideFlash('success', 'Calendar removed!');
          } else {
            this.flashMessages.showAndHideFlash('error', 'Error removing calendar account.');
          }
        } catch {
          this.flashMessages.showAndHideFlash('error', 'Error removing calendar account.');
        }
        this.selectedDeleteConnection = null;
        this.deleteConnectionShouldRemoveRooms = false;
      }
    }), {
      drop: true
    }, "deleteConnection", null));
    _defineProperty(this, "saveSettingAccessCode", _buildTask(() => ({
      context: this,
      generator: function* (code) {
        if (code.length < 4) {
          return;
        }
        try {
          const result = yield this.graphql.updateCompanyConfig({
            settingsAccessCode: code
          });
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          this.settingsAccessCode = result.settingsAccessCode;
          this.flashMessages.showAndHideFlash('success', 'Saved!');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
          throw e;
        }
      }
    }), {
      drop: true
    }, "saveSettingAccessCode", null));
    _defineProperty(this, "onBlurSettingAccessCode", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield waitForProperty(this, 'saveSettingAccessCode.isIdle', () => true);
        const {
          company
        } = this.model;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.settingsAccessCode = company.settingsAccessCode;
      }
    }), {
      drop: true
    }, "onBlurSettingAccessCode", null));
    _defineProperty(this, "handleLinkLocationTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          currentLocation,
          company
        } = this.model;
        if (!currentLocation) {
          return;
        }
        try {
          yield this.graphql.createLocation({
            id: currentLocation.id,
            // TODO remove this and change the type of currentLocation
            name: currentLocation.name,
            companyId: company.id
          });
          this.flashMessages.showAndHideFlash('success', 'Linked!');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', parseErrorForDisplay(e));
          throw e;
        }
      }
    }), {
      drop: true
    }, "handleLinkLocationTask", null));
  } // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  get googleConnections() {
    return this.model.company.connections.filter(connection => connection.provider === OauthProvider.Google);
  }
  get oauthProviders() {
    return OauthProvider;
  }
  get roomNotificationSettingsActive() {
    return this.featureConfig.isEnabled('roomMeetings.notifications');
  }
  get hasLinkedLocation() {
    return this.model.company.locations?.filter(loc => loc.id === this.state.currentLocation?.id);
  }
  get canPairDevices() {
    return this.model.company.connections.length > 0 && this.model.company.connections.some(connection => connection.roomsCount != null && connection.roomsCount > 0);
  }
  get shouldShowLinkLocationComponent() {
    return config.environment === 'development';
  }
  // Only numbers for settings access code
  validateSettingAccessCode({
    target
  }) {
    target.value = target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "featureConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "roombaMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "settingsAccessCode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.model.company.settingsAccessCode;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedDeleteConnection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "deleteConnectionShouldRemoveRooms", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "validateSettingAccessCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validateSettingAccessCode"), _class.prototype)), _class);
export { RoombaSettingsIndexController as default };